import { creatorbase } from '@round/api';
import { getTableMetaHelper } from '@round/ui-kit';
import { Meta as BaseMeta } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';

export type CreatorPostData = {
    campaignPost: creatorbase.Post | undefined;
    otherCampaignsWithCreator: creatorbase.Campaign[] | undefined;
};

export type Meta = Pick<
    BaseMeta,
    | 'isLoading'
    | 'hasError'
    | 'getCreatorImages'
    | 'getAreCreatorImagesLoading'
    | 'getRowSelectedPlatform'
    | 'onRowPlatformSelect'
> & {
    getCreatorPostData: (clientInfluencerAccountId: number) => CreatorPostData | null;
    platform: Extract<creatorbase.Platform, 'tiktok' | 'instagram'> | undefined;
    projectId?: number | null;
    campaign?: creatorbase.Campaign | null;
    onUpdate: () => void;
    isLoadingPostData?: boolean;
    areActionsDisabled?: boolean;
    addedPostIds: Set<string>;
    onPostCreated: (postId: string) => void;
    onPostDeleted: (postId: string) => void;
};

export const getTableMeta = getTableMetaHelper<Meta>();
